<template lang="jade">
	include ../../node_modules/tangram-ui/src/elements/tge-button/tge-button.jade
	include ../../node_modules/tangram-ui/src/elements/tge-callout/tge-callout.jade
	include ../../node_modules/tangram-ui/src/elements/tge-svg-icons/tge-svg-icons.jade

	.election-year
		.year-nav
			.year-nav_item(v-for="year in years", :class="{ current: year.year === currentYear, disabled: year.navDisabled }")
				.year-nav_item_inner(@click="navClick(year)")
					span.year-nav_item_text
						{{ year.year }}

					+tge-svg-icons({ icon: 'live-bullet', customAttributes: { 'v-if': 'year.live' }})
					+tge-svg-icons({ icon: 'arrow-down', customAttributes: { 'v-if': 'year.year === currentYear' }})

				+tge-callout({
					state: 'open',
					theme: 'error',
					arrowPosition: 'top-center',
					text: 'Check back on Election Night for Live Results from the 2017 State Election.',
					customAttributes: { 'v-if': 'year.navDisabled', ':tge-callout-state': 'tgeCalloutState'}
				})


</template>
<script>
	export default {
		name: "yearNav",
		props: {
			embed: {},
			year:{}
		},
		data: () => ({
			'tgeCalloutState': 'closed'
		}),
		computed: {
			years() {
				const
					years = Object.keys(this.$store.state.elections).map( (key) => {
						const { year, live, enabled, order, navDisabled } = this.$store.state.elections[key];
						return {
							year,
							live,
							enabled,
							order,
							navDisabled,
							theme: year === this.currentYear ? 'blue' : 'border-only',
							showIcon: live
						};
					})
					.filter( (election) => election.enabled )
					.sort( (a, b) => a.order - b.order );

				return years;
			},
			currentYear() {
				return this.year || this.$store.state.currentYear;
			}
		},
		methods: {
			navClick(year) {
				if (year.navDisabled) {
					this.tgeCalloutState = 'open';
					this.$el.querySelector('.tge-callout').setAttribute('tge-callout-state', 'open')
					console.log(this.tgeCalloutState)
				} else {

					if (this.embed) {
						// this.year = year.year;
						this.$emit('update:changeYear', year.year);
					} else {
						this.$store.dispatch('changeYear', year.year);
					}
				}
			}
		}
	}
</script>
<style lang="scss">
	@import "src/_commons/assets/scss/global-sass";
	@import "node_modules/tangram-ui/src/elements/tge-callout/tge-callout";

	.year-nav {
		display: flex;
		justify-content: center;
		margin-top: $m-spacing-x2;
		[election-embed="true"] & {
			margin-top: calc(#{$m-spacing} * 1.5);
			margin-bottom: 0;//$m-spacing-x2;
		}

		.tge-button:not([showicon]) {
			.tge-button_icon {display:none}
		}

		&_item {
			position: relative;
			background: white;
			border: 1px solid rgba(0,0,0,0.1);
			border-width: 1px 0;
			width: 100px;
			cursor: pointer;
			transition: all 0.3s;

			&_inner {
				display: flex;
				align-items: center;
				padding: $m-spacing $m-spacing-x2;
				justify-content: center;
			}

			&.current {
				background: #000;
				color: white;
				border-width: 1px 0;
			}

			&:not(.current):hover {
				// opacity:0.5;
				border-color: #ccc;
			}

			&:first-child {
				border-left-width:1px;
			}
			&:last-child {
				border-right-width:1px;
			}

			&_text {
				@include tgs-font-title-xs;
				line-height: 1.5;
				[tgs-font-custom-loaded=true] & {
					transform: translateY(0.075rem);
				}
			}

			.tge-svg-icon_live-bullet {
				height: 16px;
				margin-left: $m-spacing;
			}

			.tge-svg-icon_arrow-down {
				position: absolute;
			    left: 50%;
			    transform: translateX(-50%);
			    top: 100%;
			}

			.tge-callout {
				position: absolute;
				z-index: 100;
				left: 50%;
				transform: translateX(-50%);
				top: 100%;
				margin-top: $m-spacing-x3;
				@include tgs-font-base-m;
				width: 320px;

				&[tge-callout-state="open"] {
					transform: translate(-50%, 0%);
				}

				&[tge-callout-state="closed"] {
					transform: translate(-50%, -10%);
				}

				@include MQ_LowerThan(400px) {
					width: 60vw;
				}

			}

		}
	}


</style>



// WEBPACK FOOTER //
// YearNav.vue?2c9ed3a4